import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Login from './components/Login';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Layout Components
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="container">
      {children}
    </main>
    <Footer />
  </>
);

const PrivateLayout = ({ children }) => {
  const token = localStorage.getItem('google_token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Header />
      <main className="container">
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <PublicLayout>
                <Home />
              </PublicLayout>
            } />
            
            <Route path="/services" element={
              <PublicLayout>
                <Services />
              </PublicLayout>
            } />
            
            <Route path="/contact" element={
              <PublicLayout>
                <Contact />
              </PublicLayout>
            } />
            <Route path="/dashboard" element={
               <PublicLayout>
                <Dashboard />
               </PublicLayout>
            } />
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            {/* <Route path="/dashboard" element={
               <PrivateLayout>
                <Dashboard />
               </PrivateLayout>
            } /> */}
            
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;